import axios from "axios";
import { toast } from "react-toastify";
import { push } from "connected-react-router";

export const CATADVS_GET_ARTICLES_REQUEST = "CATADVS_GET_CATADVS_REQUEST";
export const CATADVS_GET_ARTICLES_SUCCESS = "CATADVS_GET_ARTICLES_SUCCESS";
export const CATADVS_GET_ARTICLES_FAIL = "CATADVS_GET_ARTICLES_FAIL";
export const getArticles = params => dispatch => {
  dispatch({
    type: CATADVS_GET_ARTICLES_REQUEST
  });
  axios
    .request({
      url: "dashboard/classified_ggs",
      params: params,
      method: "GET"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: CATADVS_GET_ARTICLES_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: CATADVS_GET_ARTICLES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const CATADVS_GET_CATEGORIES_REQUEST = "CATADVS_GET_CATEGORIES_REQUEST";
export const CATADVS_GET_CATEGORIES_SUCCESS = "CATADVS_GET_CATEGORIES_SUCCESS";
export const CATADVS_GET_CATEGORIES_FAIL = "CATADVS_GET_CATEGORIES_FAIL";
export const getCategories = params => dispatch => {
  dispatch({
    type: CATADVS_GET_CATEGORIES_REQUEST
  });
  axios
    .request({
      url: "categories",
      params: {
        post_type: "forum_post"
      },
      method: "GET"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: CATADVS_GET_CATEGORIES_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: CATADVS_GET_CATEGORIES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const CATADVS_REMOVE_ARTICLE_REQUEST = "CATADVS_REMOVE_ARTICLE_REQUEST";
export const CATADVS_REMOVE_ARTICLE_SUCCESS = "CATADVS_REMOVE_ARTICLE_SUCCESS";
export const CATADVS_REMOVE_ARTICLE_FAIL = "CATADVS_REMOVE_ARTICLE_FAIL";
export const removeArticle = ({ post_id, path }) => dispatch => {
  dispatch({
    type: CATADVS_REMOVE_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/post/remove",
      data: {
        post_id
      },
      method: "post"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: CATADVS_REMOVE_ARTICLE_SUCCESS
        });
        toast.success(data.message);
        if (path === "user") {
          dispatch(push("/dash/user/management/advs"));
        } else {
          dispatch(push("/dash/admin/category-advertisements"));
        }
      } else {
        dispatch({
          type: CATADVS_REMOVE_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        toast.warn(data.message);
      }
    });
};

export const CATADVS_GET_ARTICLE_REQUEST = "CATADVS_GET_ARTICLE_REQUEST";
export const CATADVS_GET_ARTICLE_SUCCESS = "CATADVS_GET_ARTICLE_SUCCESS";
export const CATADVS_GET_ARTICLE_FAIL = "CATADVS_GET_ARTICLE_FAIL";
export const getArticle = id => dispatch => {
  dispatch({
    type: CATADVS_GET_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "classified_gg",
      params: {
        classified_ad_id: id
      },
      method: "GET"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: CATADVS_GET_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: CATADVS_GET_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const CATADVS_AUDIT_ARTICLE_REQUEST = "CATADVS_AUDIT_ARTICLE_REQUEST";
export const CATADVS_AUDIT_ARTICLE_SUCCESS = "CATADVS_AUDIT_ARTICLE_SUCCESS";
export const CATADVS_AUDIT_ARTICLE_FAIL = "CATADVS_AUDIT_ARTICLE_FAIL";
export const auditArticle = ({
  post_category_join_id,
  category_id,
  title,
  body,
  cover_image,
  weeks,
  status,
  note
}) => dispatch => {
  let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
  params.append("classified_ad_id", post_category_join_id);
  params.append("status", status);
  params.append("category_id", category_id);
  params.append("title", title);
  params.append("body", body);
  params.append("status", status);
  if (cover_image) {
    params.append("cover_image", cover_image);
  }
  params.append("weeks", weeks);
  params.append("note", note);
  dispatch({
    type: CATADVS_AUDIT_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/classified_gg/edit",
      data: params,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: CATADVS_AUDIT_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
        dispatch(push("/dash/admin/category-advertisements"));
      } else {
        dispatch({
          type: CATADVS_AUDIT_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const CATADVS_EDIT_ARTICLE_REQUEST = "CATADVS_EDIT_ARTICLE_REQUEST";
export const CATADVS_EDIT_ARTICLE_SUCCESS = "CATADVS_EDIT_ARTICLE_SUCCESS";
export const CATADVS_EDIT_ARTICLE_FAIL = "CATADVS_EDIT_ARTICLE_FAIL";
export const editArticle = ({
  post_category_join_id,
  category_id,
  title,
  body,
  cover_image,
  status,
  weeks
}) => dispatch => {
  console.log(status);
  let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
  params.append("classified_ad_id", post_category_join_id);
  params.append("status", status);
  params.append("category_id", category_id);
  params.append("title", title);
  params.append("body", body);
  params.append("status", status);
  params.append("weeks", weeks);
  if (cover_image) {
    params.append("cover_image", cover_image);
  }
  dispatch({
    type: CATADVS_EDIT_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/classified_gg/edit",
      data: params,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: CATADVS_EDIT_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: CATADVS_EDIT_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const CATADVS_QUOTE_ARTICLE_REQUEST = "CATADVS_QUOTE_ARTICLE_REQUEST";
export const CATADVS_QUOTE_ARTICLE_SUCCESS = "CATADVS_QUOTE_ARTICLE_SUCCESS";
export const CATADVS_QUOTE_ARTICLE_FAIL = "CATADVS_QUOTE_ARTICLE_FAIL";
export const quoteArticle = ({
  vacancy_weeks,
  category_id,
  type
}) => dispatch => {
  dispatch({
    type: CATADVS_QUOTE_ARTICLE_REQUEST
  });
  if (!vacancy_weeks || !category_id || !type) {
    dispatch({
      type: CATADVS_QUOTE_ARTICLE_SUCCESS,
      msg: "",
      data: ""
    });
  } else if (type === "right") {
    dispatch({
      type: CATADVS_QUOTE_ARTICLE_SUCCESS,
      msg: "側邊廣告將在付費後立即生效",
      data: ""
    });
  } else {
    axios
      .request({
        url: "dashboard/classified_gg/headline_availability",
        params: {
          vacancy_weeks,
          category_id
        },
        method: "GET"
      })
      .then(({ data }) => {
        if (data.success) {
          dispatch({
            type: CATADVS_QUOTE_ARTICLE_SUCCESS,
            msg: "頂部廣告可能需要排期，目前最早可用發布時間為：",
            data: data.data
          });
        } else {
          dispatch({
            type: CATADVS_QUOTE_ARTICLE_FAIL,
            msg: data.message,
            errors: data.errors ? data.errors : {}
          });
          toast.warn(data.message);
        }
      });
  }
};

export const CATADVS_CREATE_ARTICLE_REQUEST = "CATADVS_CREATE_ARTICLE_REQUEST";
export const CATADVS_CREATE_ARTICLE_SUCCESS = "CATADVS_CREATE_ARTICLE_SUCCESS";
export const CATADVS_CREATE_ARTICLE_FAIL = "CATADVS_CREATE_ARTICLE_FAIL";
export const createArticle = ({
  category_id,
  position,
  weeks,
  path,
  status
}) => dispatch => {
  // console.log(category_id, title, body, cover_image, weeks, type, status);
  // let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
  // params.append("category_id", category_id);
  // params.append("title", title);
  // params.append("body", body);
  // params.append("status", status);
  // if (cover_image) {
  //   params.append("cover_image", cover_image);
  // }
  // params.append("weeks", weeks);
  // params.append("position", type);
  // if (path === "admin") {
  //   params.append("note", note);
  // }
  dispatch({
    type: CATADVS_CREATE_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/classified_gg/create",
      data: {
        category_id,
        position,
        weeks,
        status
      },
      method: "POST"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: CATADVS_CREATE_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
        if (path === "admin") {
          dispatch(
            push(
              "/dash/admin/category-advertisements/" + data.data.id + "/edit"
            )
          );
          // dispatch(push("/admin/category-advertisements"));
        } else {
          dispatch(
            push("/dash/user/management/advs/" + data.data.id + "/edit")
          );
        }
      } else {
        dispatch({
          type: CATADVS_CREATE_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const CATADVS_PAY_ARTICLE_REQUEST = "CATADVS_PAY_ARTICLE_REQUEST";
export const CATADVS_PAY_ARTICLE_SUCCESS = "CATADVS_PAY_ARTICLE_SUCCESS";
export const CATADVS_PAY_ARTICLE_FAIL = "CATADVS_PAY_ARTICLE_FAIL";
export const payArticle = ({
  classified_ad_id,
  source_token,
  begin_time
}) => dispatch => {
  let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
  params.append("classified_ad_id", classified_ad_id);
  params.append("source_token", source_token);
  params.append("begin_time", begin_time);
  dispatch({
    type: CATADVS_PAY_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/classified_gg/pay",
      data: params,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: CATADVS_PAY_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
        dispatch(push("/dash/user/management/advs"));
      } else {
        dispatch({
          type: CATADVS_PAY_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};
